// extracted by mini-css-extract-plugin
export default {"bg":"login_bg__21O9k","center":"login_center__dlhc1","logo":"login_logo__9ETF1","loginform":"login_loginform__FXi3e"};